// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@stoneage/XDL/types";
import { color, getSystemColor } from "@stoneage/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import LinkPresentationPropsDefault from "@insite/mobius/Link/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { fontConfig } from "@stoneage/XDL/constants";
import { css } from "styled-components";
import { getProp } from "@insite/mobius/utilities";
import { StyledIcon } from "@insite/mobius/Link";

export default {
    defaultProps: {
        ...LinkPresentationPropsDefault,
        mergeCss: true,
        color: "text.link",
        hoverStyle: {
            color: getSystemColor("primary"),
        },
        typographyProps: {
            ...fontConfig.regularSingleLine,
            weight: fontConfig.weight.medium,
            textDecoration: "none",
            css: css`
                letter-spacing: 0;
            `,
        },
        css: css`
            & > ${TypographyStyle}, & > ${IconWrapper} {
                transition: all ${getProp("theme.transition.duration.regular", "300")}ms ease-in-out;
            }

            & > ${StyledIcon} {
                ${({ iconAlignment }: any) => css`
                    ${iconAlignment === "right"
                        ? css`
                              margin-left: 4px;
                          `
                        : css`
                              margin-right: 4px;
                          `};
                `}
            }
            &[disabled] {
                cursor: not-allowed;
                &,
                &:hover,
                &:focus {
                    & ${TypographyStyle} {
                        color: ${color("text.link", 0.33)};
                    }

                    ${IconWrapper} {
                        opacity: 0.33;
                        color: ${color("text.link")};
                    }
                }
            }

            &.small {
                font-size: ${fontConfig.smallSingleLine.size}px;
                line-height: ${fontConfig.smallSingleLine.lineHeight};
            }

            &.xSmall {
                font-size: ${fontConfig.xSmallSingleLine.size}px;
                line-height: ${fontConfig.xSmallSingleLine.lineHeight};
            }
        `,
    },
} as xBaseTheme["link"];
